<template>
    <div class="row" :data-expand="isExpand ? true : null">
        <div class="cells" v-on:click="toggleExpand()">
            <span class="cell" data-size="status" data-align="center">
                <span class="icon-status" :data-icon="histItem.userNm == 'System' ? 'system' : 'user'" :title="histItem.userNm == 'System' ? 'System' : 'User'">System</span>
            </span>
            <span class="cell" data-size="date">
                <time datetime="">{{convertUtcTimezoneToLocal(histItem.timeLine)}}</time>
            </span>
            <span class="cell" data-size="type">
                {{ $t('AUDIT.FILTER.WHITELIST')}}<!--화이트리스트-->
            </span>
            <span class="cell" data-size="user">
                {{histItem.userNm}}
            </span>
            <span class="cell">
                {{$t('AUDIT.LABEL.CASE.MODIFY')}}<!--수정-->&nbsp;:&nbsp;<a href="#">{{histItem.prgrSetNm}}</a>
            </span>
            <span class="cell" data-align="center">
                <button type="button" class="buttons-icon" data-type="ghost" data-icon="expand" :data-expand="isExpand ? true : null">collapse / expand</button>
            </span>
        </div>

        <div class="expand-container">
            <div-loading v-if="isExpand && evntLog == null"></div-loading>
            <!-- inner tables -->
            <table class="tbl-inner" v-if="evntLog !== null">
                <caption>{{ $t('AUDIT.LABEL.CASE.EDIT_BLOCK_LIST')}}</caption>
                <colgroup>
                    <col style="width: 185px;">
                </colgroup>
                <thead>
                <tr>
                    <th scope="col">{{ $t('AUDIT.LABEL.HEADER.ITEM')}}<!--항목--></th>
                    <th scope="col">{{ $t('AUDIT.LABEL.HEADER.FROM')}}<!--변경 전--></th>
                    <th scope="col">{{ $t('AUDIT.LABEL.HEADER.TO')}}<!--변경 후--></th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <th>{{ $t('AUDIT.WHITELIST.NAME')}}<!--이름--></th>
                    <td>{{bfEvntLog.titl}}</td>
                    <td v-if="chkDiffTitl"><ins>{{evntLog.titl}}</ins></td>
                    <td v-else>{{evntLog.titl}}</td>
                </tr>
                <tr>
                    <th>{{ $t('AUDIT.WHITELIST.DESCRIPTION')}}<!--설명--></th>
                    <td>{{bfEvntLog.desc}}</td>
                    <td v-if="chkDiffDesc"><ins>{{evntLog.desc}}</ins></td>
                    <td v-else>{{evntLog.desc}}</td>
                </tr>
                <tr>
                    <th>{{ $t('AUDIT.WHITELIST.APPLIED_RESOURCES')}}<!--적용된 리소스--></th>
                    <td class="size-fit">
                        <table class="tbl-inner-details">
                            <caption>Resource</caption>
                            <thead>
                            <tr>
                                <th scope="col">{{ $t('AUDIT.WHITELIST.HEADER.ACCOUNT')}}<!--계정(별칭)--></th>
                                <th scope="col">{{ $t('AUDIT.WHITELIST.HEADER.PRODUCT')}}<!--제품--></th>
                                <th scope="col">{{ $t('AUDIT.WHITELIST.HEADER.REGION')}}<!--리전--></th>
                                <th scope="col">{{ $t('AUDIT.WHITELIST.HEADER.RESOURCE_ID')}}<!--리소스 ID--></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="rsrc of bfEvntLog.combi">
                                <td>{{rsrc.accId}}({{getAccountAlias(rsrc.accId)}})</td>
                                <td>{{rsrc.rsrcType}}</td>

                                <td>{{rsrc.rgnId}}</td>
                                <td>{{rsrc.instId}}</td>
                            </tr>
                            </tbody>
                        </table>
                    </td>
                    <td class="size-fit">
                        <table class="tbl-inner-details">
                            <caption>Resource</caption>
                            <thead>
                            <tr class="ins">
                                <th scope="col">{{ $t('AUDIT.WHITELIST.HEADER.ACCOUNT')}}<!--계정(별칭)--></th>
                                <th scope="col">{{ $t('AUDIT.WHITELIST.HEADER.PRODUCT')}}<!--제품--></th>
                                <th scope="col">{{ $t('AUDIT.WHITELIST.HEADER.REGION')}}<!--리전--></th>
                                <th scope="col">{{ $t('AUDIT.WHITELIST.HEADER.RESOURCE_ID')}}<!--리소스 ID--></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="rsrc of evntLog.combi">
                                <td>{{rsrc.accId}}({{getAccountAlias(rsrc.accId)}})</td>
                                <td>{{rsrc.rsrcType}}</td>
                                <td>{{rsrc.rgnId}}</td>
                                <td>{{rsrc.instId}}</td>
                            </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
                </tbody>
            </table>

        </div>
    </div>

</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: 'ExpandWhiteListModify',
        props: ['histItem'],
        data: function() {
          return {
              evntLog: null,
              bfEvntLog: null,
              isExpand: false
          }
        },
        computed: {
            getLocale: function() {
                return this.$i18n.locale
            },
            chkDiffTitl: function() {
                return this.bfEvntLog.titl !== this.evntLog.titl
            },
            chkDiffDesc: function() {
                return this.bfEvntLog.desc !== this.evntLog.desc
            }
        },
        methods: {
            convertUtcTimezoneToLocal: function(date) {
                return date == null ? '-' : this.Common.convertUtcTimezoneToLocalByLang(date, this.getLocale)
            },
            toggleExpand: function(){
                this.isExpand = !this.isExpand
                this.isExpand && this.evntLog == null ? this.parseEvntLog() : false

            },
            parseEvntLog: function() {
                if(typeof(this.histItem.evntLog) !== 'undefined'){
                    this.evntLog =  JSON.parse(this.histItem.evntLog)
                    this.evntLog.titl = _.head(this.evntLog.titl);
                    this.evntLog.desc = _.head(this.evntLog.desc);

                    let self = this
                    _.forEach(this.evntLog.combi, function(v, i){
                        self.evntLog.combi[i] = JSON.parse(v)
                    })

                    this.bfEvntLog =  JSON.parse(this.histItem.bfEvntLog)
                    this.bfEvntLog.titl = _.head(this.bfEvntLog.titl);
                    this.bfEvntLog.desc = _.head(this.bfEvntLog.desc);

                    _.forEach(this.bfEvntLog.combi, function(v, i){
                        self.bfEvntLog.combi[i] = JSON.parse(v)
                    })

                }
            },
            getAccountAlias: function(accId){

                let awsInfo = _.head(_.filter(this.$store.state.vendorInfo, {'cloudVndrId': "aws"}))
                let accNm = ''

                if(typeof(awsInfo) !== 'undefined'){
                    _.find(awsInfo.accountList, function(o){
                        o.accId = accId ? accNm = o.alias : false
                    })
                }
                return accNm
            }
        }

    }
</script>



// WEBPACK FOOTER //
// src/components/audit/expand/whiteListModify.vue